"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Identifier = exports.If = exports.Return = exports.Print = exports.CallFunc = exports.UnaryOperation = exports.UnaryOperator = exports.Operation = exports.Operator = exports.Comparisons = exports.Compare = exports.Number = exports.String = exports.Literal = exports.Declaration = exports.LoopStmt = exports.FuncDeclaration = exports.VarStmt = exports.ImportStmt = exports.Block = void 0;
class Block {
    constructor(init = []) {
        this.statements = init;
    }
    withStatement(statement) {
        return new Block([...this.statements, statement]);
    }
    toString(indent = 0) {
        const indentation = '\t'.repeat(indent);
        // Add additional indentation after every newline
        return indentation +
            this.statements.join('\n').replace(/\n/g, '\n' + indentation);
    }
}
exports.Block = Block;
class ImportStmt {
    constructor(id) {
        this.name = id;
    }
    toString() {
        return `import ${this.name}`;
    }
}
exports.ImportStmt = ImportStmt;
class VarStmt {
    constructor(decl, expr) {
        this.declaration = decl;
        this.value = expr;
    }
    toString() {
        return `var ${this.declaration} < ${this.value}`;
    }
}
exports.VarStmt = VarStmt;
class FuncDeclaration {
    constructor({ name, params }, returnType, body, returnExpr) {
        this.name = name;
        this.params = params;
        this.returnType = returnType;
        this.body = body;
        this.returnExpr = returnExpr;
    }
    toString() {
        return `> ${this.name}` + this.params.map(param => ' ' + param).join('')
            + (this.returnType ? ` -> ${this.returnType}` : '')
            + ` |\n${this.body.toString(1)}\n<`;
    }
}
exports.FuncDeclaration = FuncDeclaration;
class LoopStmt {
    constructor(value, decl, body) {
        this.value = value;
        this.var = decl;
        this.body = body;
    }
    toString() {
        return `> loop ${this.value} ${this.var} |\n${this.body.toString(1)}\n<`;
    }
}
exports.LoopStmt = LoopStmt;
class Declaration {
    constructor(name, type) {
        this.name = name;
        this.type = type;
    }
    toString() {
        return `${this.name}: ${this.type}`;
    }
}
exports.Declaration = Declaration;
class Literal {
}
exports.Literal = Literal;
class String extends Literal {
    constructor(string) {
        super();
        this.value = string;
    }
    toString() {
        return JSON.stringify(this.value);
    }
}
exports.String = String;
class Number extends Literal {
    constructor(number) {
        super();
        this.value = number;
    }
    toString() {
        return this.value;
    }
}
exports.Number = Number;
var Compare;
(function (Compare) {
    Compare["LESS"] = "less";
    Compare["EQUAL"] = "equal";
    Compare["GREATER"] = "greater";
})(Compare = exports.Compare || (exports.Compare = {}));
function compareToString(self) {
    switch (self) {
        case Compare.LESS: return '<';
        case Compare.EQUAL: return '=';
        case Compare.GREATER: return '>';
    }
}
class Comparisons {
    constructor([value, ...comparisons]) {
        this.comparisons = [];
        let lastValue = value.expr;
        for (const { expr, comparison } of comparisons) {
            this.comparisons.push({
                type: comparison,
                a: lastValue,
                b: expr
            });
            lastValue = expr;
        }
    }
    toString() {
        let str = `${this.comparisons[0].a}`;
        for (const { type, b } of this.comparisons) {
            str += ` ${compareToString(type)} ${b}`;
        }
        return `(${str})`;
    }
}
exports.Comparisons = Comparisons;
var Operator;
(function (Operator) {
    Operator["AND"] = "and";
    Operator["OR"] = "or";
    Operator["ADD"] = "add";
    Operator["MINUS"] = "minus";
    Operator["MULTIPLY"] = "multiply";
    Operator["DIVIDE"] = "divide";
    Operator["INT_DIVIDE"] = "int-divide";
    Operator["MODULO"] = "modulo";
    Operator["EXPONENT"] = "exponent";
})(Operator = exports.Operator || (exports.Operator = {}));
function operatorToString(self) {
    switch (self) {
        case Operator.AND: return '&';
        case Operator.OR: return '|';
        case Operator.ADD: return '+';
        case Operator.MINUS: return '-';
        case Operator.MULTIPLY: return '*';
        case Operator.DIVIDE: return '/';
        case Operator.INT_DIVIDE: return '//';
        case Operator.MODULO: return '%';
        case Operator.EXPONENT: return '^';
    }
}
class Operation {
    constructor(operator, expr, val) {
        this.type = operator;
        this.a = expr;
        this.b = val;
    }
    toString() {
        return `(${this.a} ${operatorToString(this.type)} ${this.b})`;
    }
}
exports.Operation = Operation;
var UnaryOperator;
(function (UnaryOperator) {
    UnaryOperator["NEGATE"] = "negate";
    UnaryOperator["NOT"] = "not";
})(UnaryOperator = exports.UnaryOperator || (exports.UnaryOperator = {}));
function unaryOperatorToString(self) {
    switch (self) {
        case UnaryOperator.NEGATE: return '-';
        case UnaryOperator.NOT: return 'not ';
    }
}
class UnaryOperation {
    constructor(operator, value) {
        this.type = operator;
        this.value = value;
    }
    toString() {
        return `${unaryOperatorToString(this.type)}${this.value}`;
    }
}
exports.UnaryOperation = UnaryOperation;
class CallFunc {
    constructor(value, params = []) {
        this.func = value;
        this.params = params;
    }
    toString() {
        return `{${this.func}${this.params.map(param => ' ' + param).join('')}}`;
    }
}
exports.CallFunc = CallFunc;
class Print {
    constructor(expr) {
        this.value = expr;
    }
    toString() {
        return `print ${this.value}`;
    }
}
exports.Print = Print;
class Return {
    constructor(expr) {
        this.value = expr;
    }
    toString() {
        return `return ${this.value}`;
    }
}
exports.Return = Return;
class If {
    constructor(condition, statement, maybeElse) {
        this.condition = condition;
        this.then = statement;
        this.else = maybeElse;
    }
    toString() {
        return `if ${this.condition} then ${this.then}`
            + (this.else ? ` else ${this.else}` : '');
    }
}
exports.If = If;
class Identifier {
    constructor(name, modules = []) {
        this.name = name;
        this.modules = modules;
    }
    identifier(name) {
        return new Identifier(name, [...this.modules, this.name]);
    }
    toString() {
        return this.modules.map(mod => mod + '.').join('') + this.name;
    }
}
exports.Identifier = Identifier;
